module.exports = __webpack_public_path__ + "img/cognitive_img04.4cab140f.jpg";